import script from "./LiveSportOverviewFavourites.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveSportOverviewFavourites.vue?vue&type=script&setup=true&lang=js"

import "./LiveSportOverviewFavourites.vue?vue&type=style&index=0&id=415ba79b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-415ba79b"]])

export default __exports__